<template>
  <PageWrap page-title="Solicitantes">
    <b-row>
      <b-col md="4" lg="3">
        <BfInput
          v-model="searchTerm"
          data-key="key"
          label="Búsqueda"
          placeholder="Buscar por nombre"
          @update="updateSearch"
        />
      </b-col>
      <b-col md="4" lg="3">
        <BfInput
          v-model="searchTermDNI"
          data-key="key"
          label="Búsqueda"
          placeholder="Buscar por NIF"
          @update="updateSearch"
        />
      </b-col>
    </b-row>

    <LoadingIndicator v-if="loadingData" />

    <BfTable
      v-else
      :data="clients"
      :columns="tableColumns"
      border
      cell-class-name="tasaciones-small-cell"
      @row-click="tableRowClick"
    >
      <span slot="nombre" slot-scope="{row}" class="tasaciones-table-marker">
        {{row.nombre}}
      </span>
    </BfTable>

    <b-row class="mt-5">
      <b-col>
        <BfButton :to="{name: 'cliente'}" tag="router-link">Nuevo Solicitante</BfButton>
      </b-col>
      <b-col class="text-right">
        <BfPagination
          v-if="clients.length"
          :current-page="currentPage"
          :total="totalRows"
          :page-size="perPage"
          :pager-count="9"
        />
      </b-col>
    </b-row>
  </PageWrap>
</template>

<script>
/* eslint-disable object-curly-newline */
import PageWrap from '@/components/PageWrap';
import LoadingIndicator from '@/components/LoadingIndicator';
import router from '@/router';
import { clientAPI } from '@/api';

export default {
  name: 'ClientsList',

  data() {
    return {
      clients: [],
      currentPage: 1,
      dateFrom: '',
      dateTo: '',
      loadingData: false,
      perPage: 15,
      searchTerm: '',
      searchTermDNI: '',
      totalRows: 0,
    };
  },

  created() {
    this.loadData();
  },

  methods: {

    async loadData() {
      this.loadingData = true;

      try {
        const {
          data: { data, current_page: currentPage, per_page: perPage, total },
        } = await clientAPI.getAll({
          page: this.currentPage,
          perPage: this.perPage,
          search: this.searchTerm,
          nif: this.searchTermDNI,
          to: this.dateTo !== '' ? this.dateTo : undefined,
        });

        this.clients = data;
        this.totalRows = total;
        this.perPage = Number(perPage);
        this.currentPage = currentPage;
      } finally {
        this.loadingData = false;
      }
    },

    updateSearch() {
      this.loadData();
    },

    tableRowClick({ row, column }) {
      if (column.property === 'nombre') {
        const { id } = row;
        router.push({ name: 'cliente', params: { id: `${id}` } });
      }
    },

    updatePagination(newPage) {
      if (newPage !== this.currentPage) {
        this.currentPage = newPage;

        this.loadData();
      }
    },
  },

  computed: {
    tableColumns() {
      return [
        {
          label: 'Nombre',
          dataKey: 'nombre',
          sortable: true,
          width: 700,
        },
        {
          label: 'NIF',
          dataKey: 'nif',
          sortable: true,
        },
        {
          label: 'Ciudad',
          dataKey: 'ciudad',
          sortable: true,
        },
      ];
    },
  },

  components: {
    LoadingIndicator,
    PageWrap,
  },
};
</script>
